
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.5 4.5v8m-6.462-1.57a7.17 7.17 0 0 0 3.109 3.665 6.752 6.752 0 0 0 4.64.785 6.927 6.927 0 0 0 4.066-2.453A7.419 7.419 0 0 0 15.5 8.352a7.432 7.432 0 0 0-1.521-4.622 6.945 6.945 0 0 0-3.999-2.57 6.745 6.745 0 0 0-4.66.649 7.147 7.147 0 0 0-3.206 3.573M4.5 5.5h-3v-3m9.083 3H7.458c-.386 0-.757.158-1.03.44A1.522 1.522 0 0 0 6 7c0 .398.154.78.427 1.06.274.282.645.44 1.031.44h2.084c.386 0 .757.158 1.03.44.274.28.428.662.428 1.06s-.154.78-.427 1.06c-.274.282-.645.44-1.031.44H6","stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    